import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { StethoscopeIcon, ActivityIcon, ShieldCheckIcon, SparklesIcon, HeartPulseIcon, ChevronRightIcon, ChevronLeftIcon } from 'lucide-react';
const services = [{
  title: 'Kieferorthopädie',
  icon: ActivityIcon,
  desc: 'Für ein gerades und gesundes Lächeln in jedem Alter.'
}, {
  title: 'Homöopathie',
  icon: ShieldCheckIcon,
  desc: 'Ganzheitliche und sanfte Begleitung Ihrer Behandlung.'
}, {
  title: 'Funktionsdiagnostik',
  icon: StethoscopeIcon,
  desc: 'Präzise Analyse für ein harmonisches Kausystem.'
}, {
  title: 'Parodontologie',
  icon: HeartPulseIcon,
  desc: 'Gesundes Zahnfleisch als Fundament für Ihre Zähne.'
}, {
  title: 'Zahnimplantate',
  icon: ShieldCheckIcon,
  desc: 'Fester Biss und natürliche Ästhetik mit Implantaten.'
}, {
  title: 'Professionelles Bleaching',
  icon: SparklesIcon,
  desc: 'Strahlend weiße Zähne schonend und effektiv.'
}, {
  title: 'Veneers',
  icon: SparklesIcon,
  desc: 'Perfekte Ästhetik durch hauchdünne Keramikschalen.'
}, {
  title: 'Sportzahnarzt',
  icon: ActivityIcon,
  desc: 'Leistungssteigerung und Schutz für Athleten.'
}];
export function ServicesSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const {
        scrollLeft,
        clientWidth
      } = scrollRef.current;
      const scrollTo = direction === 'left' ? scrollLeft - clientWidth / 2 : scrollLeft + clientWidth / 2;
      scrollRef.current.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-32 bg-weiss overflow-hidden" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6 mb-16 flex justify-between items-end" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-162">
          <h2 className="text-4xl md:text-5xl font-poppins font-bold text-schwarz mb-4 uppercase tracking-tight" data-id="element-163">
            Unser Leistungsportfolio
          </h2>
          <p className="text-gray-medium text-lg max-w-2xl font-lora" data-id="element-164">
            Wir vereinen alle Facetten der Zahnmedizin und Zahnästhetik unter
            einem Dach.
          </p>
        </motion.div>

        <div className="hidden md:flex space-x-4" data-id="element-165">
          <button onClick={() => scroll('left')} className="w-12 h-12 border border-schwarz flex items-center justify-center hover:bg-schwarz hover:text-weiss transition-colors" aria-label="Scroll left" data-id="element-166">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-167" />
          </button>
          <button onClick={() => scroll('right')} className="w-12 h-12 border border-schwarz flex items-center justify-center hover:bg-schwarz hover:text-weiss transition-colors" aria-label="Scroll right" data-id="element-168">
            <ChevronRightIcon className="w-5 h-5" data-id="element-169" />
          </button>
        </div>
      </div>

      <div className="relative" data-id="element-170">
        <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-6 px-6 md:px-12 pb-16 hide-scrollbar" data-id="element-171">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="snap-center shrink-0 w-[320px] h-[400px] bg-weiss border-l-4 border-navy border-y border-r border-gray-200 p-8 flex flex-col justify-between text-schwarz shadow-sm hover:shadow-xl transition-shadow cursor-pointer group service-card" data-id="element-172">
              <service.icon className="w-10 h-10 text-navy mb-6" data-id="element-173" />

              <div data-id="element-174">
                <h3 className="text-2xl font-poppins font-bold mb-4" data-id="element-175">
                  {service.title}
                </h3>
                <p className="text-gray-medium text-base font-lora leading-relaxed" data-id="element-176">
                  {service.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}